module.exports = __webpack_public_path__ + "img/sign.349867c1.png";